/** core libraries & third party packages */
import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { motion, useMotionValueEvent, useScroll } from "framer-motion";

/** icons */
import { BiCartAdd } from "react-icons/bi";
import { TbLogout } from "react-icons/tb";
import { MdOutlineAdd } from "react-icons/md";
import { FaRegCircleUser } from "react-icons/fa6";

/** component */
import Authentication from "../auth/Authentication";

/** custom hooks & query & context */
import { useCartQuery } from "../../../hooks/useReactQuery";

/** utils */
import { handleGetUserFromLocalStorage, logout } from "../../../utils/common";

/** style */
import "./Navbar.scss";

/** interfaces */
import { IUser } from "../../../Interfaces/user";

const Navbar: React.FC = () => {
  // const navigate = useNavigate();
  const { scrollY } = useScroll();
  const [loginModal, setLoginModal] = useState(false);
  const [navbar, setNavbar] = useState(false);
  const [isOpenProfileMenu, setIsOpenProfileMenu] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const currentUser = JSON.parse(
    handleGetUserFromLocalStorage() as string
  ) as IUser;

  // query
  const { Prefetch: prefetchGetAllCart } = useCartQuery();
  const getAllCarts = prefetchGetAllCart(currentUser?._id);

  const handleLoginModal = () => {
    if (currentUser === null) {
      setLoginModal((prev) => !prev);
    } else {
      // navigate("/profile");
      setIsOpenProfileMenu((prev) => !prev);
    }
  };
  const handleClickOutside = (e: { target: any }) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setIsOpenProfileMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleClickOutside, true);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleClickOutside, true);
    };
  }, []);

  useMotionValueEvent(scrollY, "change", (newValue) => {
    const previousValue = scrollY.getPrevious();
    if (
      previousValue !== undefined &&
      newValue > previousValue &&
      newValue > 150
    ) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  });
  return (
    <motion.div
      variants={{
        visible: { y: 0 },
        hidden: { y: window.innerWidth < 767 ? "-110%" : "-130%" },
      }}
      animate={navbar ? "hidden" : "visible"}
      transition={{ duration: 0.35, ease: "easeInOut" }}
      className={` navbar_header_container`}
    >
      <div className="navbar  w-[96%]">
        <header
          className={` "border-b-[1.5px] border-[#F2F0F1]"} top_navbar_container sm:h-[100px] h-[70px]`}
        >
          <div className="top_navbar_left">
            <div className="navbar_container ">
              <nav>
                <ul>
                  <li>
                    <NavLink to="/">Home</NavLink>
                    <NavLink to="/products">Products</NavLink>
                    <NavLink to="/about-us">About us</NavLink>
                    {/* <NavLink to="/cart">Wishlist</NavLink> */}
                  </li>
                </ul>
              </nav>
              {/* {location.pathname === "/products" && (
                <div className="top_navbar_search_bar">
                  <div className="search_icon">
                    <IoIosSearch />
                  </div>
                  <input type="text" placeholder="Search for products..." />
                </div>
              )} */}
            </div>
          </div>

          <div className="navbar_right_icons">
            {currentUser !== null && (
              <NavLink to="/cart" aria-label="Cart">
                <div className="relative">
                  <div className="cart_icon">
                    <BiCartAdd size={25} />
                  </div>
                  {getAllCarts.data !== undefined &&
                    getAllCarts.data?.data.length !== 0 && (
                      <div className="absolute top-[-10px] right-[-15px] bg-black  text-white rounded-full min-w-[18px] min-h-[18px] flex justify-center items-center text-[10px]">
                        {getAllCarts.data?.data.length}
                      </div>
                    )}
                </div>
              </NavLink>
            )}

            {/* <NavLink to={"/profile"}> */}
            <div className="relative" ref={menuRef}>
              <div className="user_icon" onClick={handleLoginModal}>
                <FaRegCircleUser />
              </div>
              {isOpenProfileMenu && currentUser !== null && (
                <div className="absolute right-0 mt-2 sm:w-56 w-52  bg-gray-100 rounded-xl shadow-lg  z-10 !p-2  pt-3">
                  <div className="absolute top-[-8px] right-3 w-0 h-0 border-l-[8px] border-r-[8px] border-b-[8px] border-l-transparent border-r-transparent border-b-gray-100"></div>
                  <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-3 px-2">
                      <img
                        src="https://placehold.co/40"
                        alt="Profile"
                        className="w-10 h-10 rounded-full object-cover"
                      />
                      <div>
                        <p className="font-semibold text-sm capitalize">
                          {currentUser.name}
                        </p>
                        <p className="text-gray-500 text-xs">
                          {currentUser.email}
                        </p>
                      </div>
                    </div>
                    <hr />
                    <div className="px-3 flex flex-col gap-2">
                      {currentUser.role.includes("admin") && (
                        <NavLink to={"product/create-product"}>
                          <div className="flex gap-2 items-center text-sm font-medium tracking-wider">
                            <MdOutlineAdd size={20} />
                            Add Products
                          </div>
                        </NavLink>
                      )}

                      <button
                        className="w-full text-left text-sm font-medium tracking-wider ml-1 hover:text-red-600 bggray-200 flex gap-2 items-center"
                        onClick={() => {
                          logout();
                        }}
                      >
                        <TbLogout size={20} /> Logout
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* </NavLink> */}
          </div>
        </header>
      </div>
      <Authentication
        handleLoginModal={handleLoginModal}
        loginModal={loginModal}
      />
    </motion.div>
  );
};

export default Navbar;
